document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
    const wrapper = document.querySelector('more-payment-options-link');

    if (!wrapper) return;

    const link = wrapper.querySelector('a#more-payment-options-link');

    if (!link) return;

    const img = document.createElement('img');
    img.className = 'payment-options';
    img.src = 'https://cdn.shopify.com/s/files/1/1444/9702/files/Logos.png?v=1769375231';
    img.alt = 'More payment options';

    // Optional: keep click behavior
    img.style.cursor = 'pointer';
    img.addEventListener('click', (e) => {
        e.preventDefault();
        link.click();
    });

    link.replaceWith(img);  
    }, 1000);
});

